import React from 'react';
import './App.css';
import Signup from './Signup';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>My react / firebase project</h2>
        <Signup />
      </header>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js